import { useIntl } from 'gatsby-plugin-intl'
import { navigate } from '@reach/router'

export default function useNavigate() {
  const { locale } = useIntl()

  const sanitizeNavigationTarget = (to: string) => {
    return to ? `/${locale}/${to}`.replace('//', '/') : ''
  }

  return {
    linkHref: sanitizeNavigationTarget,
    navigate(to: string, state?: object) {
      return navigate(sanitizeNavigationTarget(to), { state })
    },
  }
}
